import React from "react";
import "./IndustrySection.css";

// ✅ MUI Icons
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const industries = [
    {
        title: "Food & Beverages",
        desc: "Dine-In POS, Table Management, KOT, Catering, Delivery, Chef Panel, Loyalty & Analytics.",
        points: [
            "Fast live billing",
            "Table-wise tracking",
            "KOT printing",
            "Repeat customer analytics",
        ],
        button: "Explore Restaurant Dashboard",
        icon: <RestaurantIcon />,
    },
    {
        title: "Grocery & Meat",
        desc: "Barcode Billing, Inventory, Stock Alerts, Supplier Tracking, Expiry Alerts & Margin Reports.",
        points: [
            "Live stock tracking",
            "Auto low-stock alerts",
            "Batch & expiry management",
            "Purchase vs sales analytics",
        ],
        button: "Explore Grocery Dashboard",
        icon: <ShoppingCartIcon />,
    },
    {
        title: "Travel & Logistics",
        desc: "Booking Management, Route & Fleet Tracking, Driver Assignment, Trip Billing & Payment Tracking.",
        points: [
            "Real-time trip tracking",
            "Automated invoicing",
            "Driver performance tracking",
            "Booking analytics",
        ],
        button: "Explore Travel Dashboard",
        icon: <LocalShippingIcon />,
    },
];

export default function IndustrySection() {
    return (
        <div className="industry-section">

            {/* HEADER */}
            <div className="industry-header">
                <p className="industry-subtitle">INDUSTRY SOLUTIONS</p>
                <h2 className="industry-title">Built for Your Business</h2>
            </div>

            {/* CARDS */}
            <div className="industry-grid">
                {industries.map((item, index) => (
                    <div className="industry-card" key={index}>

                        {/* TOP */}
                        <div className="industry-card-header">
                            <div className="industry-icon">
                                {item.icon}
                            </div>
                            <h3>{item.title}</h3>
                        </div>

                        {/* DESC */}
                        <p className="industry-desc">{item.desc}</p>

                        {/* POINTS */}
                        <ul className="industry-list">
                            {item.points.map((point, i) => (
                                <li key={i}>{point}</li>
                            ))}
                        </ul>

                        {/* BUTTON */}
                        <button className="industry-btn">
                            {item.button} →
                        </button>

                    </div>
                ))}
            </div>

        </div>
    );
}